import {useRef} from "react";

export function useSpiderfier(map, mapMarkers, mapGeoItems = new Map()) {
    const originalPos = useRef(new Map());
    const isSpiderfied = useRef(false);

    const distance = 20;

    const findGroupForMarker = (target, markers, map, projection, dist) => {
        const marker = mapMarkers.get(target) || mapGeoItems.get(target);

        return markers.filter((m) =>
            m.id !== target && isOverlap(marker, m, map, projection, dist)
        ).concat(marker);
    }

    const isOverlap = (m1, m2, map, projection, maxPixelDistance) => {
        const p1 = projection.fromLatLngToPoint(m1.getPosition());
        const p2 = projection.fromLatLngToPoint(m2.getPosition());

        const scale = Math.pow(2, map.getZoom());
        const dx = (p1.x - p2.x) * scale;
        const dy = (p1.y - p2.y) * scale;

        return Math.sqrt(dx * dx + dy * dy) < maxPixelDistance;
    }

    const spiderfyGroup = (group, map, projection) => {
        const center = group[0].getPosition();
        const world = projection.fromLatLngToPoint(center);

        const count = group.length;
        const angleStep = (Math.PI * 2) / count;
        const radius = 0.00003 * Math.pow(2, 20 - map.getZoom());

        group.forEach((marker, i) => {
            const angle = angleStep * i;

            const px = world.x + radius * Math.cos(angle);
            const py = world.y + radius * Math.sin(angle);

            const newLatLng = projection.fromPointToLatLng({ x: px, y: py });
            marker.setPosition(newLatLng);
        });
    }


    return {
        addMarker(marker) {
            originalPos.current.set(marker.id, marker.getPosition());
        },

        removeMarker(markerId) {
            originalPos.current.delete(markerId);
        },

        spiderfy(markerId, callback) {
            if (!map) return;

            const markers = [...mapMarkers, ...mapGeoItems].map(([, marker]) => marker).filter(marker => marker.visible);
            if (markers.length === 0) return;

            if (markers.length === 1) {
                callback()
                return;
            }

            const projection = map.getProjection();
            if (!projection) return;

            const group = findGroupForMarker(markerId, markers, map, projection, distance);

            if (group.length > 1) {
                spiderfyGroup(group, map, projection);
                isSpiderfied.current = true;
                return
            }

            this.unspiderfy();
            callback();
        },

        unspiderfy() {
            for (const [id, pos] of originalPos.current.entries()) {
                const marker = mapMarkers.get(id) || mapGeoItems.get(id);
                if (marker) marker.setPosition(pos);
            }
            isSpiderfied.current = false;
        }
    };
}
